import { render, staticRenderFns } from "./VolumeMicrophone.vue?vue&type=template&id=efcecf30&scoped=true"
import script from "./VolumeMicrophone.vue?vue&type=script&lang=js"
export * from "./VolumeMicrophone.vue?vue&type=script&lang=js"
import style0 from "./VolumeMicrophone.vue?vue&type=style&index=0&id=efcecf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcecf30",
  null
  
)

export default component.exports